/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// react
import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import BASESvgIcon from "../../../../@BASE/core/BASESvgIcon";


const EditSubheader = (props) => {

  const { data } = props;

  return (
    <Box className="w-full mb-24 md:mb-0">
      <Stack 
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <BASESvgIcon size={20}>{data.icon}</BASESvgIcon>
        <BASESvgIcon size={20}>{data.label}</BASESvgIcon>
        <span className="text-sm ml-2">{data.value}</span>
      </Stack>
    </Box>
  )
};

export default EditSubheader;
